import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss'],
  standalone: true,
  imports: [MatButtonModule],
})

export class PopUpComponent implements OnInit {

  /****************** Input and Output decorators ******************/
  @Input() header: string;
  @Input() content: string;
  @Input() button1Text: string;
  @Input() button2Text: string;

  /**
   * Constructor
   * @param dialogRef 
   * @param data 
   */
  constructor(public dialogRef: MatDialogRef<PopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  /** ngOnInit */
  ngOnInit() {
  }

  /** on button clicked */
  onButtonClicked(button: string) {
    this.dialogRef.close(button);
  }
}
